import * as z from "zod/v4";

export const OMSMetricsRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});

export const OMSMetricsResponseSchema = z.object({ value: z.number() });

const CarrierShipmentCountSchema_ = z.object({
  carrier: z.string(),
  count: z.number(),
});
export const CarrierShipmentCountSchema: z.ZodType<CarrierShipmentCount> =
  CarrierShipmentCountSchema_;
export interface CarrierShipmentCount
  extends z.infer<typeof CarrierShipmentCountSchema_> {}

export const ShipmentsByCarrierResponseSchema = z.object({
  carriers: z.array(CarrierShipmentCountSchema),
});

export const timeGrain = ["daily", "weekly", "monthly"] as const;
export type TimeGrain = (typeof timeGrain)[number];
export const TimeGrainSchema = z.enum(timeGrain);

export const CarrierVolumeOverTimeRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});

const CarrierVolumeByPeriodSchema_ = z.object({
  period: z.string(),
  carriers: z.array(CarrierShipmentCountSchema),
});
export const CarrierVolumeByPeriodSchema: z.ZodType<CarrierVolumeByPeriod> =
  CarrierVolumeByPeriodSchema_;
export interface CarrierVolumeByPeriod
  extends z.infer<typeof CarrierVolumeByPeriodSchema_> {}

export const CarrierVolumeOverTimeResponseSchema = z.object({
  data: z.array(CarrierVolumeByPeriodSchema),
});

const FulfillmentCountByDateSchema_ = z.object({
  date: z.string(),
  count: z.number(),
});
export const FulfillmentCountByDateSchema: z.ZodType<FulfillmentCountByDate> =
  FulfillmentCountByDateSchema_;
export interface FulfillmentCountByDate
  extends z.infer<typeof FulfillmentCountByDateSchema_> {}

export const FulfillmentsOverTimeRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});

export const FulfillmentsOverTimeResponseSchema = z.object({
  data: z.array(FulfillmentCountByDateSchema),
});

const DateValueSchema_ = z.object({ date: z.string(), value: z.number() });
export const DateValueSchema: z.ZodType<DateValue> = DateValueSchema_;
export interface DateValue extends z.infer<typeof DateValueSchema_> {}

export const AvgDaysToFulfillOverTimeRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});

export const AvgDaysToFulfillOverTimeResponseSchema = z.object({
  data: z.array(DateValueSchema),
});

const CarrierAvgDeliveryTimeSchema_ = z.object({
  carrier: z.string(),
  avgDaysToDeliver: z.number(),
});
export const CarrierAvgDeliveryTimeSchema: z.ZodType<CarrierAvgDeliveryTime> =
  CarrierAvgDeliveryTimeSchema_;
export interface CarrierAvgDeliveryTime
  extends z.infer<typeof CarrierAvgDeliveryTimeSchema_> {}

export const AvgTimeToDeliverByCarrierResponseSchema = z.object({
  carriers: z.array(CarrierAvgDeliveryTimeSchema),
});

const ServiceLevelAvgDeliveryTimeSchema_ = z.object({
  serviceLevel: z.string(),
  avgDaysToDeliver: z.number(),
});
export const ServiceLevelAvgDeliveryTimeSchema: z.ZodType<ServiceLevelAvgDeliveryTime> =
  ServiceLevelAvgDeliveryTimeSchema_;
export interface ServiceLevelAvgDeliveryTime
  extends z.infer<typeof ServiceLevelAvgDeliveryTimeSchema_> {}

export const AvgTimeToDeliverByServiceLevelResponseSchema = z.object({
  serviceLevels: z.array(ServiceLevelAvgDeliveryTimeSchema),
});

const CarrierSpendSchema_ = z.object({
  carrier: z.string(),
  totalCost: z.number(),
});
export const CarrierSpendSchema: z.ZodType<CarrierSpend> = CarrierSpendSchema_;
export interface CarrierSpend extends z.infer<typeof CarrierSpendSchema_> {}

const CarrierSpendByPeriodSchema_ = z.object({
  period: z.string(),
  carriers: z.array(CarrierSpendSchema),
});
export const CarrierSpendByPeriodSchema: z.ZodType<CarrierSpendByPeriod> =
  CarrierSpendByPeriodSchema_;
export interface CarrierSpendByPeriod
  extends z.infer<typeof CarrierSpendByPeriodSchema_> {}

export const CarrierSpendOverTimeRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});

export const CarrierSpendOverTimeResponseSchema = z.object({
  data: z.array(CarrierSpendByPeriodSchema),
});

export const SpendByCarrierResponseSchema = z.object({
  carriers: z.array(CarrierSpendSchema),
});

const CarrierTotalAdjustmentSchema_ = z.object({
  carrier: z.string(),
  totalAdjustment: z.number(),
});
export const CarrierTotalAdjustmentSchema: z.ZodType<CarrierTotalAdjustment> =
  CarrierTotalAdjustmentSchema_;
export interface CarrierTotalAdjustment
  extends z.infer<typeof CarrierTotalAdjustmentSchema_> {}

export const TotalAdjustmentByCarrierResponseSchema = z.object({
  carriers: z.array(CarrierTotalAdjustmentSchema),
});

const CarrierSurchargeSchema_ = z.object({
  carrier: z.string(),
  totalSurchargeAmount: z.number(),
  surchargeCount: z.number(),
});
export const CarrierSurchargeSchema: z.ZodType<CarrierSurcharge> =
  CarrierSurchargeSchema_;
export interface CarrierSurcharge
  extends z.infer<typeof CarrierSurchargeSchema_> {}

const CarrierSurchargeByPeriodSchema_ = z.object({
  period: z.string(),
  carriers: z.array(CarrierSurchargeSchema),
});
export const CarrierSurchargeByPeriodSchema: z.ZodType<CarrierSurchargeByPeriod> =
  CarrierSurchargeByPeriodSchema_;
export interface CarrierSurchargeByPeriod
  extends z.infer<typeof CarrierSurchargeByPeriodSchema_> {}

export const CarrierSurchargesOverTimeRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});

export const CarrierSurchargesOverTimeResponseSchema = z.object({
  data: z.array(CarrierSurchargeByPeriodSchema),
});

const CarrierAvgLabelCostSchema_ = z.object({
  carrier: z.string(),
  avgLabelCost: z.number(),
});
export const CarrierAvgLabelCostSchema: z.ZodType<CarrierAvgLabelCost> =
  CarrierAvgLabelCostSchema_;
export interface CarrierAvgLabelCost
  extends z.infer<typeof CarrierAvgLabelCostSchema_> {}

export const AvgLabelCostByCarrierResponseSchema = z.object({
  carriers: z.array(CarrierAvgLabelCostSchema),
});

const CarrierAvgAdjustmentSchema_ = z.object({
  carrier: z.string(),
  avgAdjustment: z.number(),
});
export const CarrierAvgAdjustmentSchema: z.ZodType<CarrierAvgAdjustment> =
  CarrierAvgAdjustmentSchema_;
export interface CarrierAvgAdjustment
  extends z.infer<typeof CarrierAvgAdjustmentSchema_> {}

export const AvgAdjustmentByCarrierResponseSchema = z.object({
  carriers: z.array(CarrierAvgAdjustmentSchema),
});

const ServiceLevelShipmentCountSchema_ = z.object({
  serviceLevel: z.string(),
  count: z.number(),
});
export const ServiceLevelShipmentCountSchema: z.ZodType<ServiceLevelShipmentCount> =
  ServiceLevelShipmentCountSchema_;
export interface ServiceLevelShipmentCount
  extends z.infer<typeof ServiceLevelShipmentCountSchema_> {}

const ServiceLevelVolumeByPeriodSchema_ = z.object({
  period: z.string(),
  serviceLevels: z.array(ServiceLevelShipmentCountSchema),
});
export const ServiceLevelVolumeByPeriodSchema: z.ZodType<ServiceLevelVolumeByPeriod> =
  ServiceLevelVolumeByPeriodSchema_;
export interface ServiceLevelVolumeByPeriod
  extends z.infer<typeof ServiceLevelVolumeByPeriodSchema_> {}

export const ServiceLevelVolumeOverTimeRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});

export const ServiceLevelVolumeOverTimeResponseSchema = z.object({
  data: z.array(ServiceLevelVolumeByPeriodSchema),
});

const ServiceLevelShippingMarginSchema_ = z.object({
  serviceLevel: z.string(),
  shippingMargin: z.number(),
});
export const ServiceLevelShippingMarginSchema: z.ZodType<ServiceLevelShippingMargin> =
  ServiceLevelShippingMarginSchema_;
export interface ServiceLevelShippingMargin
  extends z.infer<typeof ServiceLevelShippingMarginSchema_> {}

const ServiceLevelShippingMarginByPeriodSchema_ = z.object({
  period: z.string(),
  serviceLevels: z.array(ServiceLevelShippingMarginSchema),
});
export const ServiceLevelShippingMarginByPeriodSchema: z.ZodType<ServiceLevelShippingMarginByPeriod> =
  ServiceLevelShippingMarginByPeriodSchema_;
export interface ServiceLevelShippingMarginByPeriod
  extends z.infer<typeof ServiceLevelShippingMarginByPeriodSchema_> {}

export const ServiceLevelShippingMarginOverTimeRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});

export const ServiceLevelShippingMarginOverTimeResponseSchema = z.object({
  data: z.array(ServiceLevelShippingMarginByPeriodSchema),
});

const ShippingMarginByPeriodSchema_ = z.object({
  period: z.string(),
  shippingMargin: z.number(),
});
export const ShippingMarginByPeriodSchema: z.ZodType<ShippingMarginByPeriod> =
  ShippingMarginByPeriodSchema_;
export interface ShippingMarginByPeriod
  extends z.infer<typeof ShippingMarginByPeriodSchema_> {}

export const ShippingMarginOverTimeRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});

export const ShippingMarginOverTimeResponseSchema = z.object({
  data: z.array(ShippingMarginByPeriodSchema),
});
